<template>
  <el-card class="card-main">
    <el-form inline ref="searchForm">
      <el-form-item prop="projectId">
        <el-select v-model="searchForm.projectId" clearable filterable placeholder="请选择所属项目" @change="projectChange">
          <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="orderType">
        <el-select v-model="searchForm.orderType" placeholder="请选择工单类型" clearable>
          <el-option v-for="(item, index) in maintenanceWorkTypeList" :label="item.dicValue" :value="item.dicCode"
            :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="orderStatus">
        <el-select v-model="searchForm.orderStatus" placeholder="请选择工单状态" clearable>
          <el-option v-for="([key, value], index) of orderStatusMap" :label="value" :value="key"
            :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="createUserName">
        <el-input v-model="searchForm.createUserName" placeholder="请输入发起人" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-date-picker class="picker" v-model="datePicker" type="daterange" unlink-panels range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="dateChange">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>

    <div class="mb20">
      <el-button @click="onAdd" type="primary" icon="el-icon-plus">新增工单</el-button>
      <el-dropdown v-if="$ButtonShow('LPI_SEL_04')" class="ml20" placement="bottom-start">
        <el-button type="primary">
          导出<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item style="width: 70px;">
            <CustomExport type="6" buttonType="text" :params="{ ...searchForm }">明细</CustomExport>
          </el-dropdown-item>
          <el-dropdown-item>
            <CustomExport type="7" buttonType="text" :params="{ ...searchForm }">清单</CustomExport>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <el-table class="global-table" v-loading="loading" :data="tableData">
      <el-table-column label="所属项目" show-overflow-tooltip prop="projectName"></el-table-column>
      <el-table-column label="工单类型" show-overflow-tooltip prop="orderTypeName"></el-table-column>
      <el-table-column label="工单内容" show-overflow-tooltip prop="orderContent"></el-table-column>
      <el-table-column label="作业日期" show-overflow-tooltip prop="orderDate"></el-table-column>
      <el-table-column label="提交时间" show-overflow-tooltip prop="ctime"></el-table-column>
      <el-table-column label="发起人" show-overflow-tooltip prop="createUserName"></el-table-column>
      <el-table-column label="办理人" show-overflow-tooltip prop="commentUser"></el-table-column>
      <el-table-column label="当前节点" show-overflow-tooltip prop="taskName"></el-table-column>
      <el-table-column label="工单状态" show-overflow-tooltip prop="orderStatus">
        <template v-slot="{ row }">{{ orderStatusMap.get(row.orderStatus) }}</template>
      </el-table-column>
      <el-table-column label="已耗时" show-overflow-tooltip prop="time"></el-table-column>
      <el-table-column label="操作" width="200px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" v-if="row.processId" @click="showProcess(row)">查看</el-button>
          <el-button type="text" v-if="row.processId" @click="delInstance(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <global-pagination @size-change="loadData" @current-change="loadData" :current-page.sync="page"
      :page-size.sync="size" :total="total">
    </global-pagination>

    <el-drawer :size="'500px'" direction="rtl" title="审批详情" :visible.sync="processVisible">
      <instance-preview v-if="processVisible" :node-id="selectInstance.nodeId" :instance-id="selectInstance.instanceId"
        :type="type" @handler-after="handlerAfter"></instance-preview>
    </el-drawer>

    <w-dialog :ok-loading="submitLoading" :title="`发起 - ${selectForm.formName}`" closeFree width="1100px"
      v-model="openItemDl" okText="提 交" @cancel="openItemDl = false" @ok="submitForm">
      <initiate-process ref="processForm" @render-ok="submitLoading = false" :code="selectForm.formId" v-if="openItemDl"
        @fail="submitLoading = false" @ok="submitSuccess" />
    </w-dialog>
  </el-card>
</template>

<script>
import InstancePreview from '@/views/wflow/workspace/approval/ProcessInstancePreview'
import InitiateProcess from "@/views/wflow/workspace/InitiateProcess"
import { delProcessInst } from '@/api/process'
import { orderStatus } from '@/utils/dict'
export default {
  name: 'ProcessWorkOrder',
  components: { InstancePreview, InitiateProcess },
  data() {
    return {
      processVisible: false,
      selectInstance: {
        instanceId: '',
        nodeId: ''
      },
      submitLoading: false,
      openItemDl: false,
      searchForm: {
        projectId: '',
        orderType: '',
        orderStatus: '',
        createUserName: '',
        startTime: '',
        endTime: ''
      },
      loading: false,
      orderStatusMap: orderStatus,
      maintenanceWorkTypeList: [],
      tableData: [],
      page: 1,
      size: 10,
      total: 0,
      datePicker: [],
      type: 'yh'
    }
  },
  filters: {
  },
  watch: {
  },
  computed: {
    customer() {
      return this.$store.state.customer
    },
    projectList() {
      return this.$store.state.projectList || []
    },
    selectForm() {
      return {
        formName: '养护工单',
        formId: 'wfAA1728887695099' + this.customer
      }
    }
  },
  created() {
    if (this.$route.query.projectId || this.$route.query.startTime && this.$route.query.endTime) {
      this.searchForm.projectId = this.$route.query.projectId
      this.searchForm.startTime = this.$route.query.startTime
      this.searchForm.endTime = this.$route.query.endTime
      this.datePicker = [this.$route.query.startTime, this.$route.query.endTime]
    }
    this.loadData()
    this.loadDict()
  },
  methods: {
    projectChange(val) {
      if (!val) {
        this.searchForm.projectId = ''
      }
    },
    dateChange(val) {
      console.log(val);
      if (val) {
        this.searchForm.startTime = val[0]
        this.searchForm.endTime = val[1]
      } else {
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
      }
    },
    loadDict() {
      this.$axios.get(this.$apis.common.selectDicByList, { dicType: 'maintenanceWorkType' }).then(res => {
        this.maintenanceWorkTypeList = res.maintenanceWorkType || []
      })
    },
    onSearch() {
      this.page = 1
      this.tableData = []
      this.loadData()
    },
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.process.selectLcWorkOrderByPage, {
        page: this.page,
        size: this.size,
        ...this.searchForm
      }).then((res) => {
        this.tableData = res.list || []
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },
    onAdd() {
      this.openItemDl = true
      this.submitLoading = true
    },
    delInstance(row) {
      this.$confirm('删除后将失去该流程实例所有数据且无法恢复，是否继续 ?', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delProcessInst(row.processId).then(rsp => {
          this.loadData()
          this.$ok(rsp, '删除流程实例成功')
        }).catch(err => {
          this.$err(err, '删除流程实例失败')
        })
      })
    },
    submitSuccess() {
      this.openItemDl = false
      this.submitLoading = false
      this.loadData()
    },
    submitForm() {
      this.$refs.processForm.validate((validForm, validProcess) => {
        if (validForm && validProcess) {
          this.submitLoading = true
          this.$refs.processForm.submit()
        } else {
          this.$message.warning("请完善表单/流程选项😥")
        }
      })
    },
    showProcess(row) {
      console.log(row);
      this.processVisible = true
      this.selectInstance = {
        instanceId: row.processId,
        nodeId: row.nodeId
      }
    },
    handlerAfter() {
      this.processVisible = false
      this.loadData()
      // node_782868998693
    }
  }
}
</script>

<style scoped lang="scss"></style>
